<template>
  <div class="log">
  <header>
    <p v-on:click="backHistory" style="padding-left: 0; " @click=""><img src="@/assets/img/back.png" alt=""></p>
     <!--<p style="padding-right: 2rem;color: #FFFFFF ">保存</p>-->
  </header>
    <div class="personalMain">
      <h3>个人优势</h3>
      <p class="personalMainP" style="color: #FFA500">写下你最擅长的事情，展示你的特别之处，分享你在工作中取得的成绩</p>
      <!--<textarea class="personalText" v-model="data.introduction">-->

      <textarea class="personalText" v-model="data.introduction">
              <!--{{data.introduction}}-->
      </textarea>
    </div>
    <div class="inforName">
      <van-button style="width: 100%;margin: 0 auto" type="primary" @click="sendPer()">保存</van-button>

    </div>
  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {
        msg: {},
        data:{},
        writer:'',
        id:""
      }
    },
    mounted(){
      this.getPer()
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      }
      ,
       getPer(){
        console.log(localStorage.getItem("userid"))
      this.$api.getMation({'data':'id,introduction',"userid":localStorage.getItem("userid")})
      .then(res=>{
        if(res.status==200){
          this.data=res.data
          this.id=res.data.id
          console.log(this.id)
         }
       })
      },
      sendPer(){
         console.log(this.id)
        this.$api.sendMation({'data[introduction]':this.data.introduction,"id":this.id})
          .then(res=>{
            if(res.status==200){
              this.data=res.data
              this.$toast("保存成功")
             this.$router.push("/editResume")
            }else {
              this.$toast(res.data)
            }
          })
      }
    }
  }
</script>
<style scoped="">
header{
  width: 100%;
  height: 65px;
  background-color: #6e9bcf;
  position: fixed;
  top:0 ;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
}
  header img{
    width: 20px;
    height: 20px;
  }
  .personalMain{
/*padding-top: 82px;*/
    padding: 8rem 18px;
  }
  .personalMainP{
    color:#FFA500 ;
    font-size: 15px;
  }
  .personalText{
    width: 100%;
    height: 10rem;
    background-color: #FAFAFA ;
    border: none;
  }
.inforName{
  width: 100%;
  position: fixed;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/editPersonal.vue